import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import { gfxURL } from '../../../../util';

class Component extends BaseComponent {
    render({ cards }) {
        return (
            <celtic-cross-sample-spread>
                <spread-partial>
                    {cards.map(card => this.renderCard(card))}
                </spread-partial>
            </celtic-cross-sample-spread>
        );
    }

    renderCard = (card) => {
        return (
            <spread-card>
                <img src={`${gfxURL}/site/decks/${this.props.deck_code}/98/${card.card_id}.jpg`} />
            </spread-card>
        );
    }
}

export default connect()(Component);
